/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { CustomOutputData } from './CustomOutputData';
const CustomOutputExtraParser = /* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('custom_output')],
    ['data', CustomOutputData],
]);
export class CustomOutputExtra extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CustomOutputExtraParser.decode(input).map(res => new CustomOutputExtra(res));
    }
    static unsafeDecode(input) {
        return CustomOutputExtra.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CustomOutputExtraParser.encode(data);
    }
    static schema() {
        return CustomOutputExtraParser.schema();
    }
}
